"use client";

import { useState } from "react";
import { Button } from "./ui/Button";

// Topics route to the right inbox. No backend needed — submitting composes a
// pre-filled email and opens the visitor's own mail app, so nothing is sent
// without them seeing and sending it themselves.
const TOPICS: { value: string; label: string; to: string }[] = [
  { value: "general", label: "General enquiry", to: "hello@coachpen.com" },
  { value: "support", label: "Help with my account", to: "support@coachpen.com" },
  { value: "schools", label: "Schools & seats", to: "schools@coachpen.com" },
  { value: "privacy", label: "Privacy & my data", to: "privacy@coachpen.com" },
];

const field =
  "mt-1 w-full rounded-xl border border-line bg-paper px-4 py-3 text-ink outline-none transition-colors focus:border-gold";
const label = "block text-sm font-bold text-ink";

export function ContactForm() {
  const [topic, setTopic] = useState("general");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const dest = TOPICS.find((t) => t.value === topic) ?? TOPICS[0];
    const subject = `[${dest.label}] from ${name || "a Coach Pen visitor"}`;
    const body = `${message}\n\n—\nFrom: ${name}${email ? ` (${email})` : ""}`;
    window.location.href = `mailto:${dest.to}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <form onSubmit={onSubmit} className="rounded-3xl border border-line bg-paper-2 p-7">
      <div className="grid gap-5">
        <div>
          <label className={label} htmlFor="topic">
            What&apos;s this about?
          </label>
          <select
            id="topic"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            className={field}
          >
            {TOPICS.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
        <div className="grid gap-5 sm:grid-cols-2">
          <div>
            <label className={label} htmlFor="name">
              Your name
            </label>
            <input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={field}
              placeholder="Alex"
            />
          </div>
          <div>
            <label className={label} htmlFor="email">
              Your email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={field}
              placeholder="you@example.com"
            />
          </div>
        </div>
        <div>
          <label className={label} htmlFor="message">
            Message
          </label>
          <textarea
            id="message"
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            className={`${field} resize-y`}
            placeholder="How can we help?"
          />
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <Button type="submit" size="sm">
            Compose email
          </Button>
          <p className="text-xs text-ink-soft">
            Opens in your email app. Nothing sends until you hit send.
          </p>
        </div>
      </div>
    </form>
  );
}
